import { ProductCalculatorsEffects } from './calculators.effects';
import { PricesEffects } from './prices.effects';
import { ProductConditionsEffects } from './product-conditions.effects';
import { ProductGroupReferencesEffects } from './product-group-references.effects';
import { ProductLoadingEffects } from './product-loading.effects';
import { TicketEffects } from './ticket.effects';

export const effects: any[] = [
  ProductCalculatorsEffects,
  TicketEffects,
  ProductGroupReferencesEffects,
  ProductLoadingEffects,
  PricesEffects,
  ProductConditionsEffects,
];
